import { Route, Routes } from "@angular/router";
import { EMPLOYEE_ROUTES } from "../features/employee/constants/routes.constant";
import { EmployeeModule } from "../features/employee/employee.module";
import { RoutePlaceholderComponent } from "@core/components/route-placeholder.component";

export const DEACTIVATE_PREFIX: string = "deactivated_";

const canActivateFn = (): boolean => false;
const deactivate = (route: Route): Route => {
  route.path = `${ DEACTIVATE_PREFIX }${ route.path }`;
  route.canActivate
    ? route.canActivate.push(canActivateFn)
    : route.canActivate = [ canActivateFn ];

  return route;
};
const _translationScope: string = "feature/customer-routes";

export const CUSTOMER_ROUTES: Routes = [
  {
    path: "",
    loadComponent: async () =>
      (await import(
        "@features/customer/components/pages/customer-overview/customer-overview.component"
      )).CustomerOverview
  },
  deactivate({
    path: "new",
    component: RoutePlaceholderComponent,
    data: {
      leaf: true,
      context: {
        breadcrumb: {
          "static": {
            translationInfo: {
              defaultText: "Unternehmen neu anlegen",
              token: "breadcrumb-label-new-customer",
              scope: _translationScope
            }
          }
        }
      }
    }
  }),
  deactivate({
    path: ":customerNumber",
    component: RoutePlaceholderComponent,
    data: {
      context: {
        breadcrumb: { apiPath: "api/customers/{customerNumber}" },
        sidebar: { apiPath: "api/menu/customer/{customerNumber}" }
      }
    },
    children: [
      {
        path: "created",
        component: RoutePlaceholderComponent
      },
      {
        path: "documents",
        component: RoutePlaceholderComponent,
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Dokumente",
                  token: "breadcrumb-label-documents",
                  scope: _translationScope
                }
              }
            }
          }
        }
      },
      {
        path: "persons-of-contact",
        component: RoutePlaceholderComponent,
        data: {
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Ansprechpartner",
                  token: "breadcrumb-label-persons-of-contact",
                  scope: _translationScope
                }
              }
            }
          }
        }
      },
      {
        path: "employees",
        loadChildren: async (): Promise<typeof EmployeeModule> =>
          (await import("../features/employee/employee.module")).EmployeeModule,
        data: {
          routes: () => EMPLOYEE_ROUTES,
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Mitarbeiter",
                  token: "breadcrumb-label-employees",
                  scope: _translationScope
                }
              }
            }
          }
        }
      },
      {
        path: "projects",
        component: RoutePlaceholderComponent,
        data: {
          leaf: true,
          context: {
            breadcrumb: {
              "static": {
                translationInfo: {
                  defaultText: "Projektebeteiligungen",
                  token: "breadcrumb-label-project-participations",
                  scope: _translationScope
                }
              }
            }
          }
        }
      }
    ]
  })
];
